<template>
  <div class="yjlist">
    <van-nav-bar
      :title="'阅卷任务('+list.length+')'"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
    <van-row v-for="(item,index) in list" :key="index" class="yjtem"   justify="space-between">
      <van-col span="18">
        <h4>{{ item.paperDesc }} {{ `(${item.paperValue}分)` }}</h4>
        <p>考试时间：{{ item.starttime }} ~ {{ item.endtime }}</p>
        <p>考试时长：{{ item.examTime }}</p>
      </van-col>
      <van-col span="5">
        <span :class="getisks(item.starttime,item.endtime)== '1' ? 'ing' : 'end'">{{ getisks(item.starttime,item.endtime)== '1'?'正在考试..':'考试已结束' }}</span>
      </van-col>
      <van-col span="24">
        <div
          class="enter"
          @click="enterTest(item.taskid,item.paperValue)"
        >进入阅卷<van-icon name="arrow" />
        </div>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        list: [],
        loading:true,
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          orderColumn:undefined,
          orderState:undefined,
          xnxq: null,
          kcmc: null,
          paperDesc:null,
        },
      }
    },
    created() {
      this.getxnxq()
    },
    methods: {
      onClickLeft() {
        this.$router.push('/teachmain')
      },
      enterTest(id,paperValue) {
        this.$router.push({ name: 'yuejuanmx', params: { id: id,paperValue:paperValue} })
      },
      getxnxq()
      {
        let that = this;
        this.$ajax.get('/teacher/examread/xnxq').then(function (res) {
          that.queryParams.xnxq =  res.data.xnxq;
          that.getyjrw();
        })
      },
      getisks(kssj,jssj)
      {
        var aData = new Date();
        if(this.$moment(kssj).valueOf()<=this.$moment(aData).valueOf()<this.$moment(jssj).valueOf())
        {
          return 1;
        }
        else
        {
          return 0;
        }

      },
      getyjrw()
      {
        let that = this;
        let data = {params:that.queryParams}
        this.$ajax.get('/teacher/examread/listtask',data).then(function (res) {
          if (res.code == 200) {
            that.list = res.rows;
            that.loading = false;
          }
        })
      },
    }
  }
</script>
<style lang="scss" scoped>
  .yjlist{
    margin-top: 4.125rem;
    padding: 0 1.25rem;
    .yjtem{
      background-color: #F8F8F8;
      margin-bottom: .9375rem;
      border-radius: 5px;
      padding: .9375rem 1.25rem;
      h4{
        margin: 0;
        line-height: 1.375rem;
        margin-bottom: .5rem;
      }
      p{
        color: #757DA3;
        font-size: .75rem;
        margin: 0;
        margin-top: .125rem;
        line-height: 1.0625rem;
      }
      .enter{
        color: #757DA3;
        display: flex;
        font-size: .875rem;
        justify-content: space-between;
        padding-top: .9375rem;
        margin-top: .625rem;
        position: relative;
        &::after{
          position: absolute;
          width: calc(100% + 2.5rem);
          left: -1.25rem;
          top: 0;
          content: '';
          height: 1px;
          background-color: #EBEBEB;
        }
      }
      span{
        font-size: .75rem;
        &.ing{
          color: #F86969;
        }
        &.end{
          color: #7469F8;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/teacherpage/yuejuanlist.vue